import React from 'react';
import { toast } from 'react-toastify';

interface Props {
  token: string;
  onClose: () => void;
}

const NewTokenDisplay: React.FC<Props> = ({ token, onClose }) => {
  const copy = () => {
    navigator.clipboard.writeText(token);
    toast.success('Token copied to clipboard!');
  };

  return (
    <div style={{ border: '1px solid #ccc', padding: 16, marginBottom: 16 }}>
      <strong>Your new API token (shown only once):</strong>
      <pre style={{ background: '#f5f5f5', padding: 8 }}>{token}</pre>
      <button className='button mr-1' onClick={copy}>Copy</button>
      {/* <button className='button' onClick={onClose}>Hide</button> */}
    </div>
  );
};

export default NewTokenDisplay;
